import { useSelector } from 'react-redux'
import { useQuery } from 'react-query'
import { useAuth0 } from '../../../contexts/auth0-context'
import endpoints from '../../../API/endpoints'
import callAPI from '../../../API/callSecureAPI'
const FIVE_MINUTES = 1000 * 60 * 5

export type TppCellMetric = {
    _id: string
    content?: string
    activities: { _id: string; title?: string; status: string }[]
}

type TppElementSupportMetricsData = {
    grouping: string
    sectionId: string | null
    rowId?: string | null
    cells: TppCellMetric[]
}

type TppElementSupportResponse = {
    data: TppElementSupportMetricsData[]
    rowIds: string[] | null
}

export const useGetTppElementSupportQuery = (
    columnId: string | null,
    highlightedOnly: boolean,
    sectionId: string | null
) => {
    const { getTokenSilently, isAuthenticated, isLoading } = useAuth0()

    // @ts-expect-error store is not typed properly
    const strategyId = useSelector((state) => state.strategy?._id)

    const getTppElementSupport = async (): Promise<TppElementSupportResponse> => {
        try {
            const token = await getTokenSilently?.({ audience: 'https://atlas.aesara.com' })

            const { url, method } = endpoints.getTppElementSupport
            const params = new URLSearchParams()
            if (highlightedOnly) params.set('highlightedOnly', 'true')
            if (sectionId) params.set('sectionId', sectionId)
            const queryString = params.toString() ? `?${params.toString()}` : ''

            const response = await callAPI(url + strategyId + '/' + columnId + queryString, method, token)

            return {
                data: response.data as TppElementSupportMetricsData[],
                rowIds: response.rowIds ?? null,
            }
        } catch (e) {
            console.log(e)
            return { data: [], rowIds: null }
        }
    }

    return useQuery<TppElementSupportResponse>(
        ['tppElementSupport', strategyId, columnId, highlightedOnly, sectionId],
        getTppElementSupport,
        {
            enabled: !!getTokenSilently && !!isAuthenticated && !isLoading && !!strategyId && !!columnId,
            cacheTime: FIVE_MINUTES,
            staleTime: FIVE_MINUTES,
            retry: 3,
        }
    )
}
